import { isProduction } from "../utils/core-helpers"
import {
    PRODUCTION,
    STAGING,
}                       from "./constant"
import {
    aandhikhola,
    amargadhi,
    annapurna_kaski,
    bagmati,
    bannigadhijayagadh,
    // barhabise,
    bheri,
    chaurpati,
    chure,
    demo,
    dhangadhi,
    dhangadhi_plus,
    durgathali,
    gauriganga,
    godawari,
    jayaprithvi,
    kailari,
    kathmandu,
    khaptadchanna,
    kirtipur,
    konjyosom,
    mahalaxmi,
    mahankal,
    mangalsen,
    masta,
    melamchi,
    mellekh,
    nalgaad,
    nawadurga,
    parashuram,
    sanfebagar,
    yipl,
}                       from "./municipalities"

export const baseDomains = {
    [PRODUCTION]: ["ims.susasan.org"],
    [STAGING]: ["ims.staging.yipl.com.np"],
}

export const defaultMunicipality = "dhangadhi"

let municipalities = {}

if (isProduction()) {
    municipalities = {
        aandhikhola,
        dhangadhi,
        kailari,
        godawari,
        kirtipur,
        konjyosom,
        sanfebagar,
        mahalaxmi,
        amargadhi,
        nawadurga,
        melamchi,
        mahankal,
        jayaprithvi,
        masta,
        bannigadhijayagadh,
        mellekh,
        chaurpati,
        durgathali,
        parashuram,
        gauriganga,
        bagmati,
        annapurna_kaski,
        mangalsen,
        bheri,
        chure,
        nalgaad,
        khaptadchanna,
        yipl
    }
} else {
    municipalities = {
        aandhikhola,
        demo,
        dhangadhi,
        kailari,
        godawari,
        kathmandu,
        kirtipur,
        konjyosom,
        sanfebagar,
        mahalaxmi,
        amargadhi,
        nawadurga,
        // barhabise,
        melamchi,
        dhangadhi_plus,
        mahankal,
        jayaprithvi,
        masta,
        bannigadhijayagadh,
        mellekh,
        chaurpati,
        durgathali,
        parashuram,
        gauriganga,
        bagmati,
        annapurna_kaski,
        mangalsen,
        bheri,
        chure,
        nalgaad,
        khaptadchanna,
        yipl
    }
}

export default municipalities



// WEBPACK FOOTER //
// ./src/config/subDomain.js